import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '@vaadin/details/theme/material/vaadin-details.js';
import { elements } from './sdb-elements.js';
import { VaadinStyleLoader } from './vaadin-style-loader.js';
/**
 * Collapsablecard element, used to wrap content in an accordion-like wrapper
 *
 * @prop {String} headline (part) - optional, used to define the cards text
 * @prop {String} headlineSize - optional, used to set the size of the headline (default 1em)
 * @prop {String} icon - optional, used to set an icon at the beginning of the card
 * @prop {String} iconSize - optional, used to set the size of the icon (default 20)
 * @prop {String} transparent - optional, used to make the card transparent
 * @slot - Unnamed slot (default slot)
 *
 */
let SDBContentCollapsableCard = class SDBContentCollapsableCard extends LitElement {
    constructor() {
        super();
        this.headline = '';
        this.headlineSize = '1em;';
        this.icon = '';
        this.iconSize = '20';
        this.opened = false;
        this.transparent = false;
        this.openedOnce = false;
        VaadinStyleLoader.registerAllStyles();
    }
    render() {
        return html `
            <vaadin-details
                class="sdb-content-collapsablecard"
                @opened-changed="${(e) => {
            this._openedChanged(e.detail.value);
        }}"
                ?opened=${this.opened}
            >
                <vaadin-details-summary
                    class="summaryContent"
                    slot="summary"
                    part="content"
                >
                    ${this.icon
            ? html ` <sdb-content-icon
                              part="icon"
                              size="${this.iconSize}"
                              .icon=${this.icon}
                          ></sdb-content-icon>`
            : ``}
                    <span
                        class="headline"
                        part="headline"
                        style="font-size:${this.headlineSize}"
                    >
                        ${this.headline}
                    </span>
                    <slot name="summary"></slot>
                </vaadin-details-summary>
                <div>
                    <slot></slot>
                </div>
            </vaadin-details>
        `;
    }
    _openedChanged(opened) {
        this.opened = opened;
        this.dispatchEvent(new CustomEvent('opened-changed', {
            detail: { value: opened },
        }));
        if (opened) {
            this.openedOnce = true;
            this.dispatchEvent(new CustomEvent('opened', {
                detail: {},
                bubbles: true,
                composed: true,
            }));
        }
        if (this.openedOnce) {
            this.dispatchEvent(new CustomEvent('iron-resize', {
                detail: {},
                bubbles: true,
                composed: true,
            }));
        }
    }
};
SDBContentCollapsableCard.styles = [
    elements,
    css `
            :host vaadin-details {
                background: white;
                font-size: 16px;
                font-family: var(--font-family);
                color: var(--text-primary);
                padding: 15px 30px 40px;

                /* OVERRULE MATERIAL DESIGN SHADOW */
                --material-shadow-elevation-2dp: none;
                --material-shadow-elevation-3dp: none;
                --material-shadow-elevation-4dp: none;
                --material-shadow-elevation-6dp: none;
                --material-shadow-elevation-8dp: none;
                --material-shadow-elevation-12dp: none;
                --material-shadow-elevation-16dp: none;
                --material-shadow-elevation-24dp: none;
            }

            :host div.summaryContent {
                display: inline-flex;
                align-items: center;
            }

            :host sdb-content-icon {
                width: 60px;
                padding-left: 10px;
            }

            :host span.headline {
                padding-left: 10px;
            }

            :host([transparent]) vaadin-details {
                background: transparent;
            }

            :host([transparent]) {
                --material-background-color: transparent;
            }

            :host vaadin-details,
            :host vaadin-details-summary {
                background: var(
                    --sdb-content-collapsablecard-background,
                    white
                );
                color: var(--sdb-content-collapsablecard-color, black);
            }

            :host vaadin-details-summary {
                cursor: pointer;
            }

            :host vaadin-details-summary::part(content) {
                display: flex;
                align-items: center;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentCollapsableCard.prototype, "headline", void 0);
__decorate([
    property({ type: String })
], SDBContentCollapsableCard.prototype, "headlineSize", void 0);
__decorate([
    property({ type: String })
], SDBContentCollapsableCard.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], SDBContentCollapsableCard.prototype, "iconSize", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentCollapsableCard.prototype, "opened", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentCollapsableCard.prototype, "transparent", void 0);
__decorate([
    state()
], SDBContentCollapsableCard.prototype, "openedOnce", void 0);
SDBContentCollapsableCard = __decorate([
    customElement('sdb-content-collapsablecard')
], SDBContentCollapsableCard);
export { SDBContentCollapsableCard };
//# sourceMappingURL=sdb-content-collapsablecard.js.map